export enum ArrowPosition {
  Left,
  Right
}

export enum ArrowDirection {
  Up,
  Down,
  Left,
  Right
}
